var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"profile-info"},_vm._l((_vm.sections),function(section){return _c('div',{key:section.name},[_c('h4',[_vm._v(_vm._s(section.title))]),_c('p',[_vm._v(_vm._s(section.value))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }